// extracted by mini-css-extract-plugin
export default {"container":"workflow-path_container__0XK0a"};